import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Pagination,
  Navigation,
  EffectCoverflow,
} from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import cardPattern from "@/assets/img/img_card_pattern.webp";

interface SwiperFanSliderProps {
  onCardClick?: (index: number) => void;
  cardsCount: number;
}

const SwiperFanSlider: React.FC<SwiperFanSliderProps> = ({
  onCardClick,
  cardsCount,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, [cardsCount]);

  const handleSlideChange = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  };

  const handleCardClick = (index: number) => {
    onCardClick?.(index);
  };

  return (
    <Swiper
      effect={"coverflow"}
      coverflowEffect={{
        rotate: 10,
        stretch: 10,
        depth: 100,
        modifier: 2,
        slideShadows: false,
      }}
      grabCursor={true}
      loop={false}
      loopAdditionalSlides={10}
      loopPreventsSliding={true}
      slidesPerView={3}
      pagination={false}
      navigation={false}
      modules={[EffectCoverflow, Pagination, Navigation]}
      className="w-full h-full max-w-md m-0 p-0 "
      onSlideChange={handleSlideChange}
      initialSlide={10}
    >
       <SwiperSlide/>
      {
      Array.from({ length: cardsCount }, (_, index) => {
        const activeIndexPlusOne = activeIndex ;
        const isCenter = activeIndexPlusOne === index;
        const isLeft = activeIndexPlusOne === index - 1;
        const isLeft2 = activeIndexPlusOne === index - 2;
        const isLeft3 = activeIndexPlusOne === index - 3;
        const isRight = activeIndexPlusOne === index + 1;
        const isRight2 = activeIndexPlusOne === index + 2;
        const isRight3 = activeIndexPlusOne === index + 3;

        return (
          <SwiperSlide
            key={index}
            className="cursor-pointer w-full h-full"
            onClick={() => !isLoading && handleCardClick(index)}
          >

            <motion.div
              className=" w-full h-full rounded-lg overflow-hidden"
              animate={{
                rotateZ: isLeft
                  ? -10
                  : isRight
                  ? 10
                  : isLeft2
                  ? -20
                  : isRight2
                  ? 20
                  : isLeft3
                  ? -30
                  : isRight3
                  ? 30
                  : isCenter
                  ? 0
                  : -30,
              }}
            >
                  <img
                    src={cardPattern}
                    alt={index.toString()}
                    className={`w-full h-full object-contain `}
                  />
              </motion.div>
          </SwiperSlide>
        );
      })}
             <SwiperSlide/>
    </Swiper>
  );
};

export default SwiperFanSlider;
